import type { GetServerSideProps } from 'next'
import type { FC, ReactNode } from 'react'
import type { ProductSummary } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { CtaBand } from '@/components/generals/cta-band'
import { HeroSection } from '@/components/landing/hero-section'
import { TrustStrip } from '@/components/landing/trust-strip'
import { ProcessSection } from '@/components/landing/process-section'
import { ProductShowcase } from '@/components/landing/product-showcase'
import { QualitySection } from '@/components/landing/quality-section'
import { ExportSection } from '@/components/landing/export-section'
import { StorySection } from '@/components/landing/story-section'
import { getFeaturedProducts } from '@/lib/catalog'

interface HomeProps {
    products: ProductSummary[]
}

const Home: FC<HomeProps> = ({ products }): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <TrustStrip />
            <ProcessSection />
            <ProductShowcase products={products} />
            <QualitySection />
            <ExportSection />
            <StorySection />
            <CtaBand />
        </Layout>
    )
}

export const getServerSideProps: GetServerSideProps<HomeProps> = async () => {
    try {
        const products = await getFeaturedProducts(6)

        return { props: { products } }
    }
    catch (error) {
        console.error('Loading featured products failed:', error instanceof Error ? error.message : error)

        return { props: { products: [] } }
    }
}

export default Home
